import { render, staticRenderFns } from "./WidgetNetMetering.vue?vue&type=template&id=01275187&"
import script from "./WidgetNetMetering.vue?vue&type=script&lang=js&"
export * from "./WidgetNetMetering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01275187')) {
      api.createRecord('01275187', component.options)
    } else {
      api.reload('01275187', component.options)
    }
    module.hot.accept("./WidgetNetMetering.vue?vue&type=template&id=01275187&", function () {
      api.rerender('01275187', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/usage/widgetnetmetering/WidgetNetMetering.vue"
export default component.exports